<template>
	<div class="MAM_queryList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.real_name" placeholder="代理商姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.agent_no" placeholder="代理商编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size v-model="queryForm.status" clearable placeholder="状态">
						<el-option label="开通" value="1"></el-option>
						<el-option label="未开通" value="2"></el-option>
						<el-option label="初始未开通" value="3"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-date-picker type="date" placeholder="开通开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
					-
					<el-date-picker type="date" placeholder="开通结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addForm()" v-if="is_userteam == 2">开通团长</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">

			<el-table :data="stockTable" size="mini" border style="width: 100%" v-loading="loading">
				<!-- <el-table-column header-align="center" align="center" prop="id" label="团长ID"></el-table-column> -->
				<el-table-column header-align="center" align="center" fixed type="index" label="ID"
					min-width="80"></el-table-column>

				<el-table-column header-align="center" align="center" prop="real_name" label="代理商姓名"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="代理商编号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="level" label="层级"></el-table-column>
				<el-table-column header-align="center" align="center" prop="inventory_two"
					label="当前库存量"></el-table-column>
				<el-table-column header-align="center" align="center" prop="active_nums" label="当前激活量">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="exchange_nums" label="当前兑换量">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="status_text" label="开通状态">
					<template slot-scope="scope">
						<span>
							{{scope.row.status_text}}
						</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="withdraw_text" label="提现状态">
					<template slot-scope="scope">
						<span v-if="scope.row.is_withdraw == 1">
							{{scope.row.withdraw_text}}
						</span>
						<span v-else style="color:#F56C6C">{{scope.row.withdraw_text}}</span>
					</template>
				</el-table-column>

				<el-table-column header-align="center" align="center" fixed="right" label="操作" width="300">
					<template slot-scope="scope">
						<el-button @click="handleInfo(scope.row,1)" type="text" size="small">成本核算</el-button>
						<el-button @click="handleInfo(scope.row,2)" type="text" size="small">奖励明细</el-button>
						<el-button v-if="is_admin !=1" @click="handleInfo(scope.row,3)" type="text" size="small">提现管理</el-button>
						<el-button v-if="is_admin ==1" @click="handleInfo(scope.row,4)" type="text" size="small">提现记录</el-button>
						<el-button @click="upDataState(scope.row,1)" type="text" size="small"
							v-if="scope.row.status == 2 && is_userteam != 1 || scope.row.status == 3 && is_userteam != 1" style="color:#67C23A">开通</el-button>
						<el-button @click="upDataState(scope.row,2)" type="text" size="small"
							v-if="scope.row.status == 1 && is_userteam != 1" style="color:#F56C6C">关闭</el-button>
						
						<!-- <el-button @click="upDataIsDeal(scope.row,1)" type="text" size="small"
							v-if="scope.row.is_deal == 2" style="color:#67C23A">启用</el-button>
						<el-button @click="upDataIsDeal(scope.row,2)" type="text" size="small"
							v-if="scope.row.is_deal == 1" style="color:#F56C6C">停用</el-button> -->
						
					</template>
				</el-table-column>

			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

		<el-dialog title="开通团长" :visible.sync="dialogVisible" width="40%" :before-close="handleClose"
			:close-on-click-modal="false">
			<el-form :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline" label-width="110px"
				label-position="left">

				<el-form-item label="代理商编号" prop="agent_no" style="margin-bottom: 20px;">
					<el-input v-model="formInline.agent_no" clearable style="width: 200px;" @blur="agentApi"></el-input>
				</el-form-item>
				<el-form-item label="代理商名称" prop="agent_nname" style="margin-bottom: 20px;">
					<el-input v-model="formInline.agent_name" disabled style="width: 200px;"></el-input>
				</el-form-item>

				<el-form-item label="代理商层级" style="margin-bottom: 20px;">
					<span style="color:#F56C6C;">{{formInline.level || 0}}</span>
					<span style="margin: 0px 40px;">当前库存量:<span
							style="color:#F56C6C;">{{formInline.inventory_two || 0}}台</span></span>
					<span>当前激活量:<span style="color:#F56C6C;">{{formInline.active_count || 0}}台</span></span>
				</el-form-item>


				<el-form-item label="提现规则" prop="active_withdraw_nums" style="margin-bottom: 20px;">
					累计库存> <el-input v-model="formInline.active_withdraw_nums" clearable style="width: 100px;"
						@input="(v)=>(formInline.active_withdraw_nums=v.replace(/[^\d]/g,''))"></el-input> 台，后自动允许提现
				</el-form-item>
				<el-form-item label="开通状态" prop="status" style="margin-bottom: 20px;">
					<el-radio-group v-model="formInline.status">
						<el-radio :label="1">开通</el-radio>
						<el-radio :label="3">初始未开通</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="determine()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import paginations from '../../components/pagination/paginations';
	export default {
		name: "teamLeaderManagementList",
		data() {
			return {
				queryForm: {
					brandId: '',
					type: '',
					terminal_sn: '',
					is_list: 2
				},
				stockTable: [],
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,
				is_userteam: null,

				dialogVisible: false,
				formInline: {
					user_id: '',
					status: 3,
					is_add: 1,
					active_withdraw_nums: 1000,

					agent_no: '',
					agent_name: '',
					level: '',
					inventory_two: '',
					active_count: '',
				},
				rules: {
					agent_no: [{
						required: true,
						message: '请输入代理商编号',
						trigger: 'blur'
					}, ],
					agent_name: [{
						required: true,
						message: '请输入代理商名称',
						trigger: 'blur'
					}, ],
					active_withdraw_nums: [{
						required: true,
						message: '请设置激活台数',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择开通状态',
						trigger: 'change'
					}],
				},
				is_admin:sessionStorage.getItem('is_admin')
			}
		},
		mounted() {
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				is_list: 2
			})
		},
		components: {
			paginations,
		},
		methods: {
			//跳转页面  成本核算 还是 奖励明细
			handleInfo(row, can) {
				if (can == 1) {
					this.$router.push({
						path: '/costing',
						query: {
							user_id: row.user_id
						}
					});
				} else if(can == 2){
					this.$router.push({
						path: '/rewardDetails',
						query: {
							user_id: row.user_id
						}
					});
				}else if(can == 3){
					this.$router.push({
						path: '/teamTixianManger',
						query: {
							user_id: row.user_id
						}
					});
				}else {
					this.$router.push({
						path: '/teamTixianRecord',
						query: {
							user_id: row.user_id
						}
					});
				}
			},
			//启用 停用
			upDataIsDeal(row, state) {
				this.$confirm("停用后将不再统计团长数据，确认停用吗?", '提 示', {
				    type: 'warning',
				    distinguishCancelAndClose: true,
				    confirmButtonText: '确 定',
				    cancelButtonText: '取 消'
				}).then(() => {
					this.$api.post("userteamleader/upUserTeamIsDeal", {
						user_id: row.user_id,
						is_deal: state
					}, res => {
						if (res.code == 0) {
							this.$message.success('修改成功');
							this.getData({
								page: this.page.currentPage,
								limit: this.page.pageSize,
								is_list: 2
							})
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {})
			},
			//开通状态
			upDataState(row, state) {
				if(state != 1){
					this.$confirm("关闭后代理将无法看到团长数据，确认关闭吗?", '提 示', {
						type: 'warning',
						distinguishCancelAndClose: true,
						confirmButtonText: '确 定',
						cancelButtonText: '取 消'
					}).then(() => {
						this.$api.post("userteamleader/upUserTeamIsDeal", {
							user_id: row.user_id,
							status: state
						}, res => {
							if (res.code == 0) {
								this.$message.success('修改成功');
								this.getData({
									page: this.page.currentPage,
									limit: this.page.pageSize,
									is_list: 2
								})
							} else {
								this.$message.error(res.msg);
							}
						})
					}).catch(() => {})
				}else{
					this.$api.post("userteamleader/upUserTeamIsDeal", {
							user_id: row.user_id,
							status: state
						}, res => {
							if (res.code == 0) {
								this.$message.success('修改成功');
								this.getData({
									page: this.page.currentPage,
									limit: this.page.pageSize,
									is_list: 2
								})
							} else {
								this.$message.error(res.msg);
							}
						})
				}
			},
			//输入代理商编号查询数据
			agentApi() {
				this.$api.post("userteamleader/getUserByAgentNo", {
					agent_no: this.formInline.agent_no
				}, res => {
					if (res.data) {
						this.formInline.user_id = res.data.id;
						this.formInline.agent_name = res.data.real_name;
						this.formInline.level = res.data.level;
						this.formInline.inventory_two = res.data.inventory_two;
						this.formInline.active_count = res.data.active_count;
					}
				})
			},
			//团长开通按钮
			determine() {
				if (this.formInline.active_withdraw_nums <= 0) {
					this.$message.error('累计库存不能小于等于0台');
					return false
				}
				this.$refs['formInline'].validate((valid) => {
					if (valid) {
						this.loading = true;
						this.$api.post("userteamleader/saveUserTeamLeader", this.formInline, res => {
							if (res.code == 0) {
								this.$message.success('提交成功');
								this.getData({
									page: this.page.currentPage,
									limit: this.page.pageSize,
									is_list: 2
								})
								this.dialogVisible = false;
								this.formInline = {
									user_id: '',
									status: 3,
									is_add: 1,
									active_withdraw_nums: 1000,
									agent_no: '',
									agent_name: '',
									level: '',
									inventory_two: '',
									active_count: '',
								}
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false;
						})
					} else {
						return false;
					}
				});
			},
			//关闭弹框
			handleClose() {
				this.dialogVisible = false;
				this.formInline = {
					user_id: '',
					status: 3,
					is_add: 1,
					active_withdraw_nums: 1000,
					agent_no: '',
					agent_name: '',
					level: '',
					inventory_two: '',
					active_count: '',
				}
			},
			//打开弹框
			addForm() {
				this.dialogVisible = true;
			},

			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.is_list = 2
				// 表单提交
				this.getData(queryForm);
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.loading = true;
				this.$api.post("userteamleader/selUserTeamLeader", params, res => {
					let data = res.data;
					if(data.length != 0){
						this.page.total = data.total; //总数
						this.stockTable = data.data;
						this.is_userteam = data.is_userteam;
					}else{
						this.page.total = 0; //总数
						this.stockTable = [];
						this.is_userteam = 3;
					}
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>